/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionWorkflowType } from './';
import {
    AccountDeletionWorkflowTypeFromJSON,
    AccountDeletionWorkflowTypeFromJSONTyped,
    AccountDeletionWorkflowTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SelectionJobTriggerRequest
 */
export interface SelectionJobTriggerRequest {
    /**
     * 
     * @type {AccountDeletionWorkflowType}
     * @memberof SelectionJobTriggerRequest
     */
    workflowType: AccountDeletionWorkflowType;
}

/**
 * Check if a given object implements the SelectionJobTriggerRequest interface.
 */
export function instanceOfSelectionJobTriggerRequest(value: object): value is SelectionJobTriggerRequest {
    if (!('workflowType' in value) || value['workflowType'] === undefined) return false;
    return true;
}

export function SelectionJobTriggerRequestFromJSON(json: any): SelectionJobTriggerRequest {
    return SelectionJobTriggerRequestFromJSONTyped(json, false);
}

export function SelectionJobTriggerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectionJobTriggerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowType': AccountDeletionWorkflowTypeFromJSON(json['workflowType']),
    };
}

export function SelectionJobTriggerRequestToJSON(value?: SelectionJobTriggerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowType': AccountDeletionWorkflowTypeToJSON(value['workflowType']),
    };
}

